// import { apiRequest } from '@/utils/config/apiRequest';
// import { _apiUrls } from '@/utils/endPoints/apiUrls';
// import { formatFileURL } from '@/utils/helpers/appHelpers';
import { Avatar, Box, Checkbox, Grid, Tab, Tabs } from '@mui/material';
import React, { useEffect, useState } from 'react'
// import ServiceCard from './ServiceCard';
// import CustomModal from '@/components/Common/CustomModal';
// import AddEditService from './AddeEditService';
// import { FILE_UPLOAD_DIR } from '@/utils/constants/constants';
// import CategoryListing from '../categories/CategoryListing';
import { LoadingButton } from '@mui/lab';
import { apiRequest } from '../../../utils/config/apiRequest';
import { apiUrl } from '../../../utils/endPoints/apiUrl';
import { FILE_UPLOAD_DIR } from '../../../utils/Constant';
import ServiceCard from './ServiceCard';
import { formatFileURL } from '../../../utils/helper/appHelpers';
// import NoData from '../../NoData';
import CustomModal from '../../comman/CustomModal';
import AddEditService from './AddeEditService';
import CategoryListing from '../categories/CategoryListing';
import AddPrintPrice from '../print-price/PrintPrice';
// import NoData from '@/components/Common/NoData';

const MODAL = {
    ADD_SERVICE: 'ADD_SERVICE',
    CATEGORIES: "CATEGORIES",
    PRINT_PRICE: 'PRINT_PRICE',
}

export default function ServiceListing({ shopId, userId, onClose = () => { } }) {
    const [services, setServices] = useState([]);
    const [selectedService, setSelectedService] = useState({});
    const [modal, setModal] = useState({ name: '', data: null });


    // Helpers
    const handleOpenModal = (name, data) => setModal({ ...modal, name, data });
    const handleCloseModal = () => setModal({ ...modal, name: '' });

    useEffect(() => {
        getServiceListing();
        getShopService();
    }, []);

    const getServiceListing = async () => {
        let { data, status } = await apiRequest({
            endUrl: apiUrl.masters.services,
            query: { paginate: 0 }
        });

        if (status) {
            setServices(data?.rows)
        }
    }

    const getShopService = async () => {
        let { data, status } = await apiRequest({
            endUrl: apiUrl.branch.serviceListing(shopId),
            query: { paginate: 0 }
        });

        if (status) {
            setSelectedService(data?.rows?.reduce((acc, item) => {
                acc[item?.serviceId?._id] = item;
                return acc;
            }, {}))
        }
    }

    const handleServiceSelect = (service) => {
        const tmp = { ...selectedService };

        if (tmp[service._id]) {
            const existing = tmp[service._id];

            if (existing._id) {
                if (existing.action === "REMOVE") {
                    tmp[service._id] = { ...existing, action: undefined, shopServiceId: undefined };
                } else {
                    tmp[service._id] = {
                        ...existing,
                        shopServiceId: existing._id, // keep ref
                        action: "REMOVE",
                    };
                }
            } else {
                delete tmp[service._id];
            }
        } else {
            tmp[service._id] = {
                serviceId: service,
                action: "ADD",
            };
        }

        setSelectedService(tmp);
    };

    const handleCustomize = (service) => {
        handleCloseModal();

        const tmp = { ...selectedService }
        tmp[service.serviceId].remarks = service?.remarks || []
        tmp[service.serviceId].thumbnail = service?.thumbnail || ''
        tmp[service.serviceId].action = 'ADD';

        setSelectedService(tmp)
    }

    const handleServiceSave = async () => {
        const payload = []

        for (const item of Object.values(selectedService)) {
            if (item.action === 'ADD') {
                let thumbnail = ''

                if (typeof item.thumbnail !== 'string' && item.thumbnail) {
                    const formData = new FormData()
                    formData.append('file', item.thumbnail);

                    let { data, status } = await apiRequest({
                        method: "POST",
                        endUrl: apiUrl.uploadFile(FILE_UPLOAD_DIR.SHOP),
                        body: formData,
                        headerType: 'form'
                    });

                    if (status) {
                        thumbnail = data?.shortUrl
                    }
                }

                payload.push({
                    shopKeeperId: userId,
                    shopServiceId: item?._id || undefined,
                    remarks: item?.remarks || [],
                    serviceId: item?.serviceId?._id,
                    thumbnail: thumbnail || undefined,
                    action: "ADD",
                })
            }
            else if (item.action === 'REMOVE') {
                payload.push({
                    serviceId: item?.serviceId?._id,
                    shopServiceId: item?._id,
                    action: "REMOVE",
                })
            }
        }


        let { status } = await apiRequest({
            method: "POST",
            endUrl: apiUrl.branch.addEditService(shopId),
            body: payload,
            showMsg: true
        });

        if (status) {
            onClose()
        }
    }

    return (
        <React.Fragment>
            <Grid container spacing={2}>
                {
                    services?.map(service => <Grid key={service?._id} item md={6}>
                        <ServiceCard
                            name={service.name}
                            alias={service.alias}
                            imgUrl={formatFileURL(selectedService?.[service?._id]?.thumbnail || service.thumbnailURL)}
                            remarks={selectedService?.[service?._id]?.remarks?.length ? selectedService?.[service?._id]?.remarks : service.remarks || []}
                            isSelected={selectedService?.[service?._id]?.action === 'ADD' || (selectedService?.[service?._id]?.action !== 'REMOVE' && Boolean(selectedService?.[service?._id]?.serviceId))}
                            onCustomize={() => {
                                handleOpenModal(MODAL.ADD_SERVICE, selectedService?.[service?._id]);
                            }}
                            onConfig={() => {
                                if (service.alias === 'PASSPORT_PHOTOS') {
                                    handleOpenModal(MODAL.CATEGORIES, { name: service.name, serviceId: service?._id, shopServiceId: selectedService?.[service?._id]?._id })
                                } else if (service.alias === 'DOCUMENTS') {
                                    handleOpenModal(MODAL.PRINT_PRICE, selectedService?.[service?._id]);
                                }
                            }}
                            onSelect={() => handleServiceSelect(service)}
                            isSaved={!!selectedService?.[service?._id]?._id}
                        />
                    </Grid>)
                }

                <Grid item md={12} display={'flex'} justifyContent={'center'}>
                    {services?.length > 0 ? <LoadingButton sx={{ width: 200 }} onClick={handleServiceSave} size='large' fullWidth variant='contained'>Save</LoadingButton> : "Data not found"}
                </Grid>
            </Grid>

            {/* Add service */}
            <CustomModal width={60} open={modal.name === MODAL.ADD_SERVICE} title={`Customize - ${modal?.data?.serviceId?.name}`} onClose={handleCloseModal}>
                <AddEditService defaultData={modal.data} serviceId={modal?.data?.serviceId?._id} onSave={handleCustomize} />
            </CustomModal>

            {/* Service category list */}
            <CustomModal width={60} open={modal.name === MODAL.CATEGORIES} title={`Categories - ${modal?.data?.name}`} onClose={handleCloseModal}>
                <CategoryListing
                    userId={userId}
                    serviceId={modal?.data?.serviceId}
                    shopServiceId={modal?.data?.shopServiceId}
                    shopId={shopId}
                    onClose={handleCloseModal}
                />
            </CustomModal>

            {/* Print Price Service */}
            <CustomModal width={60} open={modal.name === MODAL.PRINT_PRICE} title={'Configuration'} onClose={handleCloseModal}>
                <AddPrintPrice shopId={shopId} userId={userId} onClose={handleCloseModal} />
            </CustomModal>
        </React.Fragment>
    )
}
